import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Global from './Global';
import Column from './Column';

const Home = ({ marketVarieties, allMarket, brandData }) => {
    const columList = ['外汇', '股指', '能源', '金属', '债市'];

    // console.log(marketVarieties, '222222');

    return (
        <div className={styles.home}>
            {allMarket.length > 0 && <Global allMarket={allMarket} />}
            {brandData.pcImageUrl && <a href={brandData?.pcJumpUrl} className={styles.brandPicBox} target="_blank">
                <img className={styles.brandPic} src={brandData.pcImageUrl} />
            </a>}
            <div className={styles.homeColumn}>
                {allMarket.length > 0 &&
                    columList.map((item, index) => (
                        <Column title={item} marketVarieties={marketVarieties} allMarket={allMarket} key={index} />
                    ))}
            </div>
        </div>
    );
};

Home.propTypes = {
    marketVarieties: PropTypes.object,
    allMarket: PropTypes.array,
    brandData: PropTypes.object,
};

export default errorBoundary(Home);
